import CommonLayout from "layouts/DashboardLayout";
import React from "react";
import { useSearchParams } from "react-router-dom";
import ManageCategories from "layouts/manageCategories";
import SubCategories from "./SubCategory";

export default function Categories() {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams?.get("filter");

  return (
    <>
      {currentTab === "manage_categories" ? (
        <ManageCategories />
      ) : (
          <SubCategories />
      )}
    </>
  );
}